import React, { createContext, useMemo, useRef } from 'react'
import { useLocation } from '@fs/zion-router'
import useReservations from './useReservations'

export const ReservationsContext = createContext({})

export const ReservationsProvider = ({ children }) => {
  const { pathname } = useLocation()
  const hasVisitedSharedWithTemple = useRef()
  const hasVisitedReservations = useRef()
  if (pathname.includes('shared')) hasVisitedSharedWithTemple.current = true
  if (pathname.includes('reservations')) hasVisitedReservations.current = true

  const myReservations = useReservations({ hasVisitedPageToMakeCall: hasVisitedReservations })
  const sharedWithTemple = useReservations({
    isSharedWithTemple: true,
    hasVisitedPageToMakeCall: hasVisitedSharedWithTemple,
  })

  const reservationsValue = useMemo(() => ({ myReservations, sharedWithTemple }), [myReservations, sharedWithTemple])
  return <ReservationsContext.Provider value={reservationsValue}>{children}</ReservationsContext.Provider>
}
